import { Card, Flex, SimpleGrid, Text } from "@mantine/core"
import { RuleGroupType } from "react-querybuilder"

import dayjs from "@costory/shared/dayjs"

import { CostCard } from "@costory/front/components/CostCards/CostCard"
import { generateCostCardFilters } from "@costory/front/pages/DigestV2/utils/DigestUtil"

export const DigestTiles = ({
  tiles,
  costColumn,
  period,
  showPlaceholders = true,
  hideAbsoluteDiffTiles = [],
  exclusionWhereClause,
}: {
  tiles: Array<{
    label: string
    cost: { current: number; previous: number }
    contractedCost: { current: number; previous: number }
    previousDate: string
    showSparkline?: boolean
  }>
  costColumn: string
  period: string
  showPlaceholders?: boolean
  hideAbsoluteDiffTiles?: string[]
  exclusionWhereClause: RuleGroupType
}) => {
  if (!tiles || tiles.length === 0) return null
  const totalCards = 4
  const comingSoonCount = showPlaceholders
    ? Math.max(0, totalCards - tiles.length)
    : 0

  const ComingSoonCard = () => (
    <Card
      withBorder
      radius="md"
      shadow="sm"
      bg="surfaceCard"
      style={{
        cursor: "not-allowed",
        pointerEvents: "none",
      }}
    >
      <Flex
        direction="column"
        align="center"
        justify="center"
        h="100%"
        w="100%"
        gap="xs"
      >
        <Text size="lg" fw={500}>
          Coming Soon
        </Text>
        <Text size="sm" c="dimmed" ta="center">
          This feature is under development. Stay tuned!
        </Text>
      </Flex>
    </Card>
  )

  return (
    <SimpleGrid cols={4} spacing="xs" mt={10}>
      {tiles.map((tile) => {
        const filters = generateCostCardFilters(
          period,
          costColumn,
          tile.previousDate,
          exclusionWhereClause,
        )
        return (
          <CostCard
            key={tile.label}
            cost={
              costColumn === "contracted_cost"
                ? tile.contractedCost.current
                : tile.cost.current
            }
            previousCost={
              costColumn === "contracted_cost"
                ? tile.contractedCost.previous
                : tile.cost.previous
            }
            costLabel={tile.label}
            previousCostLabel={dayjs(tile.previousDate).format("MMM [']YY")}
            hideAbsoluteDiff={hideAbsoluteDiffTiles.includes(tile.label)}
            showSparkline={tile.showSparkline || false}
            customLabel={true}
            filters={filters}
          />
        )
      })}
      {Array.from({ length: comingSoonCount }).map((_, idx) => (
        <ComingSoonCard key={`coming-soon-${idx}`} />
      ))}
    </SimpleGrid>
  )
}
